import { courseIds, lpIds } from './contentIdsForImageRules'
import { Constants } from './constantInterface'

const CONSTANTS: Constants = {
  COOKIE_NAMES: {
    ACCESS_TOKEN: 'ine_access_token',
    ORIGINAL_USER_ACCESS_TOKEN: 'ine_original_access_token',
  },
  AUTH_PROVIDERS: [
    {
      color: '4185f4',
      icon:
        'https://inedev-uaa.s3.amazonaws.com/federated-login-icons/google.png',
      id: '1fcc86dc-cf5e-4eaa-88d6-02f9c6a9e0fc',
      name: 'Google',
      url: process.env.VUE_APP_GOOGLE_AUTH_URL,
    },
  ],
  ROLES: {
    INE_ADMIN: ['Admin', 'Sales', 'Support'],
    CONTENT_CREATOR: 'Content Creator',
    ACCOUNT_ADMIN: 'Account Owner',
    TEAM_ADMIN: 'Team Manager',
  },
  SUBSCRIPTIONS: {
    MANAGEABLE_STATES: ['active', 'cancelled', 'pending'],
    ACTIVE_STATE: 'active',
    PENDING_STATE: 'pending',
    FAILED_STATE: 'failed-payment',
    EXPIRED_STATE: 'expired',
    CANCELLED_STATE: 'cancelled',
    PAYPAL_PAYMENT_TYPE: 'paypal_billing_agreement',
    ADUSER_UUID: 'adf83ef3-b9ac-4383-9f13-4ac870d0130e',
  },
  PLANS: {
    PREMIUM: 'ine_premium',
    MONTHLY: 'fundamentals_monthly',
    ANNUAL: 'fundamentals_annual',
    LEGACY_ALL_ACCESS_PASS: 'aap_ind_starter_sp',
    PREMIUM_PLANS: [
      'ine_premium',
      'ine-ind-plan-boogo-2yr',
      'ine-ind-black-friday-2021-bogo-2yr',
      'pta-ind-premium-defense-bundle-1yr',
      '2_year_premium',
    ],
    BUSINESS: ['ine_b2b_pro', 'ine_b2b_enterprise', 'ine_b2b_legacy'],
    ATTACK_DEFENSE: 'ine_ind_attack_defense_lab',
    LANDING_PAGE_LINK: 'ine.com/pages/plans',
    LEGACY_PLAN_CODES: [
      'ine_1month',
      'ine_1year',
      'ine_all_access',
      'aap_ind_starter_sp',
      'ine_b2b_legacy',
      'ine_ind_monthly',
      'ine_ind_annual',
    ],
  },
  PLAN_LABELS: {
    '2_year_premium': 'Premium 2 years',
    ine_premium: 'Premium',
    ine_ind_monthly: 'Individual Monthly',
    ine_ind_annual: 'Individual Annual',
    'ine-ind-plan-boogo-2yr': 'Boogo 2 years',
    'ine-ind-black-friday-2021-bogo-2yr': 'Black Friday 2021 2 years',
    ine_legacy_streaming: 'Legacy',
    'pta-ind-premium-defense-bundle-1yr': 'Premium Defense Bundle',
  },
  LEARNING_AREAS: {
    PRIMARY: {
      Cloud: {
        id: 'd3f82c70-f4e7-428e-afd7-4b1d28988e18',
        description:
          'Cloud Computing has transformed the IT industry by opening the possibility for near infinite or at least highly elastic scalability in the delivery of enterprise applications and software as a service (SaaS). From AWS to Google, our experts will train you to work alongside the best of the best...',
        name: 'Cloud',
        slug: 'cloud',
        communitySlug: 'cloud',
      },
      'Cyber Security': {
        id: '3e1aa06f-2e9f-4789-b50d-aa027ad8dcfa',
        description:
          'Cyber security is a constantly evolving field, with innovation quickly leading to new attack vectors and defensive tactics. Our security experts stay up to date with the latest protective measures, providing training that keeps you at the forefront of cyberdefense.',
        name: 'Cyber Security',
        slug: 'cyber-security',
        communitySlug: 'cyber-security',
      },
      'Data Science': {
        id: 'db4652c5-2a80-4be8-a8f1-8852cf0e5230',
        description:
          'Conclusive data is a valuable commodity for companies, but how do we make sense of it all? Data Science compiles numerous strategies to extract and utilize information. Quality data helps companies to provide better products and services. Let our expert instructors guide you through the ins and outs of Machine Learning and other useful Data Science tools to set your team up for success.',
        name: 'Data Science',
        slug: 'data-science',
        communitySlug: 'data-science',
      },
      Networking: {
        id: 'e73fd5a8-2ead-4159-9a25-38b50ad4ab20',
        description:
          'Maintain communication throughout the system by expertly navigating the ins and outs of Networking. Earn your CCIE certification, expand your knowledge of Routing & Switching, or conquer Cisco wireless technology. Our instructors are plugged in to the best, most advanced Networking options today. Find your path here.',
        name: 'Networking',
        slug: 'networking',
        communitySlug: 'networking',
      },
    },
    SECONDARY: {
      Development: {
        id: '47306190-b47d-46d5-bbf7-06ab3cdca942',
        description:
          'Great ideas require great tools in order to become reality. Understanding the art and nuance of software development gives you an advantage that will elevate your work and opportunities. Train with top architects who will guide you through Java, Python, and more.',
        name: 'Development',
        slug: 'development',
        communitySlug: 'dev',
      },
      'IT Essentials': {
        id: 'ff0cb823-5bec-4b3a-b096-415dcf6c0adb',
        description:
          'The daily maintenance of technology products requires a broad range of knowledge and skill.  Strengthen your foundation in the basics with our experts who know them inside and out.',
        name: 'IT Essentials',
        slug: 'it-essentials',
        communitySlug: 'it',
      },
    },
    COLORS: {
      'e73fd5a8-2ead-4159-9a25-38b50ad4ab20': '#FAD740',
      'db4652c5-2a80-4be8-a8f1-8852cf0e5230': '#66C19A',
      '3e1aa06f-2e9f-4789-b50d-aa027ad8dcfa': '#BB85FF',
      'd3f82c70-f4e7-428e-afd7-4b1d28988e18': '#88A9FF',
      'ff0cb823-5bec-4b3a-b096-415dcf6c0adb': '#F647C0',
      '47306190-b47d-46d5-bbf7-06ab3cdca942': '#D73F47',
    },
  },
  ROUTING_RULES: {
    REDIRECT_IF_AUTHENTICATED: ['login', 'reset-password', 'forgot-password'],
    NAVBAR_HIDDEN: [
      'login',
      'reset-password',
      'signup',
      'admin',
      'two-factor',
      'forgot-password',
      'reset-password',
      'update-password',
      'starter-pass',
      'register',
      'registration-complete',
      'invitation-landing',
      'certificate-verified',
    ],
  },
  SEARCH: {
    CONTEXTS: ['Courses', 'Learning Paths', 'Videos', 'Bootcamps'],
    FEATURES: [
      'is_popular',
      'is_trending',
      'has_quizzes',
      'has_labs',
      'has_cc',
      'has_sample_content',
    ],
    FILTER_MAP: {
      has_quizzes: 'Have Quizzes',
      has_labs: 'Have Labs',
      is_popular: 'Popular',
      is_trending: 'Trending',
      has_cc: 'Have Closed Captioning',
      'learning_areas.name': 'Learning Areas',
      'categories.name': 'Categories',
      'instructors.name': 'Instructors',
      'instructor.name': 'Instructor',
      difficulty: 'Difficulties',
      has_sample_content: 'Included with Starter Pass',
    },
    AVAILABLE_FACETS: {
      Courses: [
        'learning_areas.name',
        'categories.name',
        'instructors.name',
        'difficulty',
        'is_popular',
        'is_trending',
        'has_quizzes',
        'has_labs',
        'has_cc',
        'has_sample_content',
      ],
      'Learning Paths': [
        'learning_areas.name',
        'categories.name',
        'instructors.name',
        'difficulty',
      ],
      Videos: ['instructor.name'],
      Bootcamps: ['instructors.name', 'learning_areas.name'],
    },
    ALGOLIA_KEYS: {
      appKey: process.env.VUE_APP_ALGOLIA_APP_KEY,
      appId: process.env.VUE_APP_ALGOLIA_APP_ID,
      coursesIndex: process.env.VUE_APP_ALGOLIA_COURSES_INDEX,
      learningPathsIndex: process.env.VUE_APP_ALGOLIA_PLAYLISTS_INDEX,
      videosIndex: process.env.VUE_APP_ALGOLIA_VIDEOS_INDEX,
      bootcampsIndex: process.env.VUE_APP_ALGOLIA_BOOTCAMPS_INDEX,
    },
    PARENTS: {
      course: 'Courses',
      learning_path: 'Learning Paths',
      bootcamp: 'Bootcamps',
    },
  },
  IMAGE_RULES: {
    LEARNING_AREA_HEROES_URL:
      'https://s3.amazonaws.com/my.ine.com/assets/learning-areas/heroes',
    COURSE_IDS_WITH_LEGACY_BACKGROUNDS: courseIds,
    LEARNING_PATH_IDS_WITH_LEGACY_BACKGROUNDS: lpIds,
  },
  CONTENT_USER_STATUS: {
    FINISHED: 'finished',
    UNSTARTED: 'unstarted',
    STARTED: 'started',
  },
  CONTENT_TYPES: {
    VIDEO: 'video',
    QUIZ: 'quiz',
    IFRAME: 'iframe',
    SLIDES: 'slides',
    LAB: 'lab',
    EXERCISE: 'exercise',
    EXERCISE_GROUP: 'exercise_group',
  },
  UNBOUNCE_SCRIPT: 'https://2b5b197e62ef4618bc48ba5c04509523.js.ubembed.com',
  BOOTCAMP_REGISTRATION_STATUS: {
    OPEN: 'open',
    COMING_SOON: 'coming_soon',
    CLOSED: 'closed',
    FINISHED: 'finished',
  },
  BOOTCAMP_CONTENT_STATUS: {
    DRAFT: 'draft',
    PUBLISHED: 'published',
    ARCHIVED: 'archived',
    UNPUBLISHED: 'unpublished',
    CONTENT_COMING_SOON: 'content_coming_soon',
    CONTENT_PUBLISHED: 'content_published',
  },
  KNOWN_API_ERRORS: {
    REQUIRES_REAUTHENTICATION: [
      "Unexpected response status from UAA, got: '401'",
      "Unexpected response status from UAA, got: '404'",
    ],
    PHP: [
      'Invalid username or password.',
      'Account is suspended',
      'Invalid refresh token',
      'Billing information not found',
      'The transaction was declined. Please use a different card or contact your bank.',
      'Billing account not found',
      'Unauthenticated.',
      'User is not yet confirmed',
      'User already confirmed',
      'Incorrect MFA code',
      'Unauthorized',
      'You do not have a phone number on your account',
      'There was a problem uploading your avatar file',
      'MFA code expired',
      'User not found',
      'Cannot upgrade this subscription',
      'Your MFA code has already been validated',
      'MFA required',
      'Confirmation code has expired',
    ],
    PYTHON: [
      'Not found.',
      'Resource not found',
      'You do not have permission to perform this action.',
      "Unexpected response status from UAA, got: '401'",
      "Unexpected response status from UAA, got: '403'",
      "Unexpected response status from UAA, got: '404'",
      'Unauthenticated.',
      'Authentication credentials were not provided.',
      'Invalid Bearer token',
      'Session status must be "started" in order to stop it',
    ],
    CODES: {
      USER_NOT_CONFIRMED: 'user_not_confirmed',
    },
  },
  FRIENDLY_ERRORS: {
    'Resource not found':
      'We were unable to locate this content. It may have been moved, deleted, or does not exist.',
    'Invalid username or password.':
      'We were unable to log you in with the username and password provided. Please check your entries and try again.',
    'Account is suspended':
      'Your account has been suspended. Please contact INE support for assistance.',
    'User is not yet confirmed':
      'Please check your email for a registration email with instructions on how to confirm your email address. Otherwise, please contact INE support',
    'Authentication credentials were not provided.':
      'You must be logged in to do that.',
    'Cannot upgrade this subscription':
      'Unfortunately, your subscription cannot currently be upgraded. Please contact INE support to complete the purchase using the Support link at the bottom of the page.',
  },
  SECURITY_AWARENESS: {
    COURSE_LINK: {
      name: 'learning-area-course',
      params: {
        area: 'CyberSecurity',
        id: 'f035c895',
        slug: 'cyber-security-awareness',
      },
    },
    QUEST_SLUG: 'quest_security_awareness',
  },
  HOME_PAGE: {
    FALLBACK_CONTENT: {
      LEARNING_PATH: {
        id:
          process.env.VUE_APP_ENVIRONMENT === 'development' ||
          process.env.VUE_APP_ENVIRONMENT === 'local'
            ? 'ee9ff705-2f7b-496f-8e04-dfdacbd0cc9c'
            : '019938d9-11cf-459b-b8ee-e662e10515f2',
        slug: 'exploit-development-student',
        name: 'Exploit Development Student',
      },
      COURSE: {
        id: 'eb1c83e7',
        name: 'Linux Exploit Development',
        slug: 'linux-exploit-development',
      },
    },
    CAROUSEL_METRICS: [
      {
        name: 'Popular',
        facet: 'is_popular',
        value: 'true',
      },
      {
        name: 'New',
        facet: 'status',
        value: 'published',
      },
      {
        name: 'Trending',
        facet: 'is_trending',
        value: 'true',
      },
    ],
  },
  VIDEO_PLAYBACK_PREFERENCES: {
    DEFAULTS: {
      isFullscreen: false,
      playbackSpeed: 1,
      volume: 90,
      isMuted: false,
    },
    STORAGE_KEY: 'videoPlaybackPreferences',
  },
  INTERESTS: [
    'a981cebe-f448-11ea-beed-12fac9350b1f',
    '7c38c72d-edf8-3b06-a058-22ef7b4c7025',
    '302eec08-0511-4c87-b2dc-816b46812959',
    '2399d6b6-70bd-3413-b4c7-ffa300ef17b1',
  ],
  PARENT_CONTENT_TYPES: [
    'course',
    'learning-path',
    'learning-area',
    'bootcamp',
    'certification',
  ],
  PARENT_CONTENT_TYPES_KEYS: {
    COURSE: 'course',
    LEARNING_PATH: 'learning-path',
    BOOTCAMP: 'bootcamp',
    CERTIFICATION: 'certification',
  },
  CONTENT_STATUS: {
    DRAFT: 'draft',
    PUBLISHED: 'published',
    ARCHIVED: 'archived',
    UNPUBLISHED: 'unpublished',
    COMING_SOON: 'coming_soon',
  },
  CERTIFICATIONS: {
    ATTEMPT_STATUS: {
      IN_PROGRESS: 'in_progress',
      REVIEW: 'review',
      FINISHED: 'finished',
      TIMEDOUT: 'timedout',
    },
    STATUS: {
      DRAFT: 'draft',
      PUBLISHED: 'published',
      ARCHIVED: 'archived',
      UNPUBLISHED: 'unpublished',
      COMING_SOON: 'coming_soon',
    },
    ALERTS: {
      ALERT_AT_10: 'cert-alert-10',
      ALERT_AT_30: 'cert-alert-30',
      ALERT_AT_45: 'cert-alert-45',
    },
    PRACTICE_STATUS: {
      IDDLE: 'Not sent',
      SUBMITTING: 'Submitting',
      SUBMITTED: 'Submitted',
      ERROR: 'Error',
    },
    USER_STATUS: {
      ATTEMPT_IN_PROGRESS: 'attempt_in_progress',
      NO_VOUCHERS: 'no_vouchers',
      ATTEMPT_IN_REVIEW: 'pending_review',
      AWARDED: 'awarded',
      CAN_DO_RETAKE: 'can_do_a_retake',
      READY_FOR_FIRST_ATTEMPT: 'ready_for_first_attempt',
      NOT_AVAILABLE: 'not_available',
    },
  },
  LABS: {
    FIXED_PARAMS: {
      WAITING_TIME: 25,
    },
    SESSION_STATUS: {
      IDDLE: 'iddle',
      STARTING: 'starting',
      STARTED: 'started',
      STOPPING: 'stopping',
      STOPPED: 'stopped',
      TERMINATING: 'terminating',
      TERMINATED: 'terminated',
      ERROR: 'error',
    },
    REGIONS: [
      'US-East',
      'US-West',
      'EU-Germany',
      'Asia-Singapore',
      'Asia-India',
    ],
  },
  PROMOTIONS: {
    PLACES: {
      HOMEPAGE_TOP: 'homepage_top_banner',
      SUBSCRIPTION_TOP: 'subscriptions_view_top_banner',
    },
    CODES: {
      LEGACY_ADD_YEAR: 'legacy-upgrade-to-premium-and-add-a-year-for-500',
      EXISTING_ADD_YEAR: 'add-a-year-to-existing-promo-for-500',
      LEGACY_EOY_ADD_YEAR: 'a5c1-0242ac170003-upgrade-premium-add-year',
      EXISTING_EOY_ADD_YEAR: 'a5c1-0242ac170003-premium-add-year',
    },
  },
  COMMUNITY_BASE_URL: 'https://community.ine.com/c/',
  MARKETING_WEBSITE_DIRECTORY_BASE_URL: 'https://ine.com/learning',
  PROFILE: {
    DEFAULT_AVATAR: 'defaults/default.png',
    MFA: {
      GOOGLE_AUTHENTICATOR: 'google_auth',
    },
    ONBOARDING: {
      STEPS: {
        PROFILE_PHOTO: 'profile_photo',
        INTEREST_AREA: 'interest_area',
        BACKUP_EMAIL: 'backup_email',
        BIRTHDAY: 'birthday',
      },
    },
  },
  PROFILE_COLORS: {
    purple: {
      dark: '#7965C6',
      base: '#A793F6',
      light: '#C4B7F9',
      lighter: '#D3C9FA',
    },
    blue: {
      dark: '#0F305C',
      base: '#3E6496',
      light: '#95B2D7',
      lighter: '#C1D8F8',
    },
    orange: {
      dark: '#D0803F',
      base: '#F19E5B',
      light: '#F6BE92',
      lighter: '#F8CEAD',
    },
    red: {
      dark: '#A43238',
      base: '#D73F47',
      light: '#DE5F66',
      lighter: '#EB9FA3',
    },
    green: {
      dark: '#4A857F',
      base: '#65AAA3',
      light: '#98C6C2',
      lighter: '#B2D4D1',
    },
    yellow: {
      dark: '#AA8F37',
      base: '#E8BF39',
      light: '#EFD47B',
      lighter: '#F3DF9C',
    },
    violet: {
      dark: '#69325B',
      base: '#9F6490',
      light: '#BF97B5',
      lighter: '#CFB1C7',
    },
    pink: {
      dark: '#BD717B',
      base: '#FD8897',
      light: '#FEAFBA',
      lighter: '#FEC3CB',
    },
    beige: {
      dark: '#83746F',
      base: '#ABA09C',
      light: '#C7BFBD',
      lighter: '#D5CFCD',
    },
  },
  JW_PLAYER: {
    MEDIA_URL: 'https://cdn.jwplayer.com/v2/media/',
  },
  YEAR_MONTHS: [
    {
      number: 1,
      name: 'January',
      days: 31,
    },
    {
      number: 2,
      name: 'February',
      days: 29,
    },
    {
      number: 3,
      name: 'March',
      days: 31,
    },
    {
      number: 4,
      name: 'April',
      days: 30,
    },
    {
      number: 5,
      name: 'May',
      days: 31,
    },
    {
      number: 6,
      name: 'June',
      days: 30,
    },
    {
      number: 7,
      name: 'July',
      days: 31,
    },
    {
      number: 8,
      name: 'August',
      days: 31,
    },
    {
      number: 9,
      name: 'September',
      days: 30,
    },
    {
      number: 10,
      name: 'October',
      days: 31,
    },
    {
      number: 11,
      name: 'November',
      days: 30,
    },
    {
      number: 12,
      name: 'December',
      days: 31,
    },
  ],
}

export default CONSTANTS
